import {React, useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import NriBuddyChatbot from '../pages/Chatbot';

const { FiMapPin, FiCalendar, FiCar, FiHome, FiCamera, FiShield, FiCheckCircle, FiArrowRight, FiClock, FiUsers, FiPhone } = FiIcons;

const TravelServices = () => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false); // State to control chatbot modal visibility

  const toggleChatbot = () => {
    setIsChatbotOpen(!isChatbotOpen);
  };
  
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };
  
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };
    useEffect(() =>{
      const timer = setInterval(handleNext, 4000);
      return () => clearInterval(timer);
    })
  
    const getPosition = (index) => {
      const total = services.length;
      const leftIndex = (currentIndex - 1 + total) % total;
      const rightIndex = (currentIndex + 1) % total;
      if (index === currentIndex) return 'active';
      if (index === leftIndex) return 'left';
      if (index === rightIndex) return 'right';
      return '';
    };
  const services = [
    {
      icon: FiCalendar,
      title: 'Trip Planning',
      description: 'Complete itinerary planning and travel coordination',
      features: ['Custom itinerary creation', 'Flight booking assistance', 'Visa documentation help', 'Travel insurance']
    },
    {
      icon: FiHome,
      title: 'Accommodation',
      description: 'Hotel and accommodation booking services',
      features: ['Hotel reservations', 'Guest house bookings', 'Family stay arrangements', 'Special requirements']
    },
    {
      icon: FiCar,
      title: 'Transportation',
      description: 'Complete ground transportation services',
      features: ['Airport pickup/drop', 'Local taxi services', 'Car rental arrangements', 'Inter-city travel']
    },
    {
      icon: FiCamera,
      title: 'Tour Guide',
      description: 'Professional tour guide and local assistance',
      features: ['Local tour guides', 'Cultural experiences', 'Shopping assistance', 'Restaurant recommendations']
    },
    {
      icon: FiUsers,
      title: 'Family Coordination',
      description: 'Family visit planning and coordination',
      features: ['Family gathering planning', 'Event coordination', 'Special occasion planning', 'Group travel management']
    },
    {
      icon: FiShield,
      title: 'Travel Support',
      description: '24/7 travel support and emergency assistance',
      features: ['24/7 helpline', 'Emergency assistance', 'Medical support', 'Lost luggage help']
    }
  ];



  const destinations = [
    {
      city: 'Mumbai',
      image: 'https://images.unsplash.com/photo-1595658658481-d53d3f999875?w=400&h=300&fit=crop',
      highlights: ['Gateway of India', 'Bollywood Studios', 'Marine Drive', 'Local Markets']
    },
    {
      city: 'Delhi',
      image: 'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=400&h=300&fit=crop',
      highlights: ['Red Fort', 'India Gate', 'Chandni Chowk', 'Lotus Temple']
    },
    {
      city: 'Bangalore',
      image: 'https://images.unsplash.com/photo-1596176530529-78163a4f7af2?w=400&h=300&fit=crop',
      highlights: ['Lalbagh Gardens', 'Bangalore Palace', 'Tech Parks', 'Cafes & Restaurants']
    },
    {
      city: 'Chennai',
      image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=300&fit=crop',
      highlights: ['Marina Beach', 'Temples', 'Cultural Centers', 'Traditional Markets']
    }
  ];

  const testimonials = [
    {
      name: 'Anita Sharma',
      location: 'Toronto, Canada',
      text: 'The team made our family reunion in Delhi absolutely perfect. Every detail was taken care of, from airport pickup to organizing family gatherings.',
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b77c?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Anita Sharma',
      location: 'Toronto, Canada',
      text: 'The team made our family reunion in Delhi absolutely perfect. Every detail was taken care of, from airport pickup to organizing family gatherings.',
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b77c?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Vikram Patel',
      location: 'London, UK',
      text: 'Excellent service! They arranged everything for our 3-week stay in Mumbai. The local guide was knowledgeable and the accommodations were perfect.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-emerald-50 to-primary-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiMapPin} className="text-4xl text-emerald-500" />
            </div>
            <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 mb-6">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
              Pay as you choose the service
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Travel Services
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Seamless travel planning and support for your visits to India. 
              From trip planning to local assistance, we make every journey memorable and stress-free.
            </p>
            <Link
              to="/login"
              className="bg-[#0E8A6A] text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-[#0b6e54] transition-colors inline-flex items-center space-x-2"
            >
              <span>Plan Your Trip</span>
              <SafeIcon icon={FiArrowRight} className="text-lg" />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Complete Travel Solutions
            </h2>
            <p className="text-xl text-gray-600">
              Everything you need for a perfect trip to India
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 hover:shadow-xl transition-shadow"
              >
                <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                  <SafeIcon icon={service.icon} className="text-2xl text-emerald-500" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center space-x-2 text-sm text-gray-700">
                      <SafeIcon icon={FiCheckCircle} className="text-emerald-500 text-xs flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>



      {/* Popular Destinations */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Popular Destinations
            </h2>
            <p className="text-xl text-gray-600">
              Explore the most popular cities for NRI visits
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {destinations.map((destination, index) => (
              <motion.div
                key={destination.city}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow"
              >
                <img
                  src={destination.image}
                  alt={destination.city}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{destination.city}</h3>
                  <ul className="space-y-1">
                    {destination.highlights.map((highlight, highlightIndex) => (
                      <li key={highlightIndex} className="flex items-center space-x-2 text-sm text-gray-600">
                        <SafeIcon icon={FiMapPin} className="text-emerald-500 text-xs flex-shrink-0" />
                        <span>{highlight}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              How It Works
            </h2>
            <p className="text-xl text-gray-600">
              Simple steps to plan your perfect trip to India
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {[
              { step: '1', title: 'Share Your Plans', description: 'Tell us your travel dates, preferences, and requirements.' },
              { step: '2', title: 'Custom Itinerary', description: 'We create a personalized itinerary based on your needs.' },
              { step: '3', title: 'Book & Confirm', description: 'Review and confirm your travel arrangements.' },
              { step: '4', title: 'Enjoy Your Trip', description: 'Travel with confidence knowing we\'re here to help.' }
            ].map((step, index) => (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-xl p-6 border border-gray-200 shadow-md text-center hover:shadow-lg transition-shadow"
              >
                <div className="w-16 h-16 bg-[#0E8A6A] text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                  {step.step}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600 text-sm">{step.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-gray-50 flex justify-center items-center relative overflow-hidden" style={{ height: '650px', paddingTop: '4rem', paddingBottom: '6rem' }}>
              {/* Animated background elements */}
              <motion.div
                animate={{
                  scale: [1, 1.2, 1],
                  rotate: [0, 90, 0],
                }}
                transition={{
                  duration: 20,
                  repeat: Infinity,
                  ease: "linear"
                }}
                className="absolute top-10 right-10 w-64 h-64 bg-blue-100 rounded-full opacity-20 blur-3xl"
              />
              <motion.div
                animate={{
                  scale: [1.2, 1, 1.2],
                  rotate: [0, -90, 0],
                }}
                transition={{
                  duration: 15,
                  repeat: Infinity,
                  ease: "linear"
                }}
                className="absolute bottom-10 left-10 w-64 h-64 bg-purple-100 rounded-full opacity-20 blur-3xl"
              />
      
              <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  className="text-center mb-12"
                >
                  <motion.h2
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="text-3xl font-bold text-gray-900 mb-4"
                  >
                    Travelers Trust Us
                  </motion.h2>
                  <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    className="text-xl text-gray-600 max-w-2xl mx-auto"
                  >
                    See what clients say about our travel services
                  </motion.p>
                </motion.div>
      
                {/* 3D Carousel Container */}
                <div className="relative mx-auto" style={{ width: '90%', maxWidth: '950px', height: '350px', perspective: '1200px' }}>
                  {testimonials.map((testimonial, index) => {
                    const total = testimonials.length;
                    const leftIndex = (currentIndex - 1 + total) % total;
                    const rightIndex = (currentIndex + 1) % total;
                    
                    let positionClass = '';
                    let style = {
                      position: 'absolute',
                      top: 0,
                      left: '50%',
                      width: '60%',
                      maxWidth: '550px',
                      transformOrigin: 'center center',
                      transformStyle: 'preserve-3d',
                      opacity: 0,
                      transition: 'all 0.8s ease-in-out',
                      filter: 'blur(8px)'
                    };
      
                    if (index === currentIndex) {
                      // Active/Center card
                      positionClass = 'z-30';
                      style = { ...style, opacity: 1, transform: 'translateX(-50%) scale(1) rotateY(0deg)', filter: 'none' };
                    } else if (index === leftIndex) {
                      // Left card
                      positionClass = 'z-20';
                      style = { ...style, opacity: 0.6, transform: 'translateX(-140%) scale(0.85) rotateY(25deg)', filter: 'blur(2px)' };
                    } else if (index === rightIndex) {
                      // Right card
                      positionClass = 'z-20';
                      style = { ...style, opacity: 0.6, transform: 'translateX(40%) scale(0.85) rotateY(-25deg)', filter: 'blur(2px)' };
                    }
      
                    return (
                      <div key={index} className={positionClass} style={style}>
                        {/* Sticky note container */}
                        <div className="bg-[#edf7f4] rounded-2xl shadow-2xl p-8 relative" style={{ minHeight: '320px' }}>
                          {/* Quote frame border */}
                          <div className="absolute inset-4 border-2 border-emerald-600/20 rounded-lg">
                            {/* Top quote */}
                            <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 text-5xl font-bold text-[#0E8A6A]">❝</div>
                            {/* Bottom quote */}
                            <div className="absolute -bottom-5 left-1/2 transform -translate-x-1/2 text-5xl font-bold text-[#0E8A6A]">❞</div>
                          </div>
      
                          {/* Polaroid photo with paper clip}
                          <div className="absolute -top-6 -right-4 bg-white p-2 shadow-xl z-20" style={{ width: '120px', transform: 'rotate(8deg)' }}>
                            {/* Paper clip 
                            <div className="absolute -top-3 right-3 w-6 h-8 border-2 border-gray-600 rounded-t-full" 
                                 style={{ borderBottom: 'none', transform: 'rotate(15deg)' }}>
                              <div className="absolute top-0 left-1/2 w-3 h-3 bg-gray-600 rounded-full transform -translate-x-1/2"></div>
                            </div>
                            
                            <img src={testimonial.image} alt={testimonial.name} className="w-full h-28 object-cover" />
                            <div className="bg-white pt-1 text-center">
                              <p className="text-xs text-gray-700">{testimonial.name}</p>
                            </div>
                          </div>
      
                          {/* Content */}
                          <div className="relative z-10 pt-6 px-4 h-full flex flex-col justify-center">
                            <p className="text-gray-900 text-base leading-snug mb-4 font-medium text-center mt-8">
                              {testimonial.text}
                            </p>
      
                            {/* Star rating */}
                            <div className="flex justify-center gap-1 mb-3 text-yellow-500">
                              ★★★★★
                            </div>
      
                            {/* Name and location */}
                            <div className="text-center">
                              <p className="text-sm text-gray-700">
                                <span className="font-bold">{testimonial.name}</span>
                                <br />
                                <span className="text-gray-500 text-xs">{testimonial.location}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
      
                  {/* Navigation Buttons */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 flex gap-6 z-50" style={{ bottom: '-60px' }}>
                    <button
                      onClick={handlePrev}
                      className="bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-[#0E8A6A] transition-colors duration-300"
                      style={{ width: '40px', height: '40px', border: 'none', cursor: 'pointer', fontSize: '18px' }}
                      aria-label="Previous testimonial"
                    >
                      &#10094;
                    </button>
                    <button
                      onClick={handleNext}
                      className="bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-[#0E8A6A] transition-colors duration-300"
                      style={{ width: '40px', height: '40px', border: 'none', cursor: 'pointer', fontSize: '18px' }}
                      aria-label="Next testimonial"
                    >
                      &#10095;
                    </button>
                  </div>
                </div>
              </div>
            </section>

      {/* 24/7 Support */}
      <section className="py-16 bg-[#0E8A6A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center text-white"
          >
            <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiPhone} className="text-3xl text-white" />
            </div>
            <h2 className="text-3xl font-bold mb-4">24/7 Travel Support</h2>
            <p className="text-xl text-emerald-100 mb-8 max-w-2xl mx-auto">
              Our travel support team is available round-the-clock to assist you during your journey. 
              From flight changes to emergency support, we're here to help.
            </p>
            <div className="flex items-center justify-center space-x-4 text-lg">
              <SafeIcon icon={FiPhone} className="text-2xl" />
              <a className="font-bold" href="https://wa.me/919618222498">Travel Helpline: +91 9618222498</a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Ready to Plan Your Next Trip?
            </h2>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Let us handle all the details while you focus on creating memories with your loved ones. 
              Start planning your perfect trip to India today.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                onClick={toggleChatbot}
                className="bg-[#0E8A6A] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#0b6e54] transition-colors"
              >
                Plan Your Trip
              </Link>
              <Link
                to="/login"
                className="border-2 border-[#0E8A6A] text-[#0E8A6A] px-8 py-3 rounded-lg font-semibold hover:bg-emerald-50 transition-colors"
              >
                Sign Up Now
              </Link>
            </div>
          </motion.div>
          {isChatbotOpen && (
        <NriBuddyChatbot onClose={toggleChatbot} />
      )}
        </div>
      </section>
    </div>
  );
};

export default TravelServices;